import { render, staticRenderFns } from "./CvsStatus.pug?vue&type=template&id=e924a2ae&scoped=true&lang=pug&"
import script from "./CvsStatus.vue?vue&type=script&lang=js&"
export * from "./CvsStatus.vue?vue&type=script&lang=js&"
import style0 from "./CvsStatus.scss?vue&type=style&index=0&id=e924a2ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e924a2ae",
  null
  
)

export default component.exports